import apiClient from './client';
import { nonce } from '../utils/runtime';

const CREWS_BASE = '/wp-json/pfandpirat/v1/crews';

export async function loadCrews() {
  const data = await apiClient.get(CREWS_BASE);
  return Array.isArray(data) ? data : [];
}

export async function createCrew(title) {
  return apiClient.post(CREWS_BASE, { title });
}

export async function joinCrew(crewId) {
  return apiClient.post(`${CREWS_BASE}/${crewId}/join`);
}

export async function loadPendingCrewMembers(crewId) {
  if (!crewId) return [];
  const data = await apiClient.get(`${CREWS_BASE}/${crewId}/pending-members`);
  return Array.isArray(data) ? data : [];
}

export async function approveCrewMember(crewId, userId) {
  return apiClient.post(`${CREWS_BASE}/${crewId}/approve-member`, { user_id: userId });
}

export async function rejectCrewMember(crewId, userId) {
  return apiClient.post(`${CREWS_BASE}/${crewId}/reject-member`, { user_id: userId });
}

export async function removeCrewMember(crewId, userId) {
  return apiClient.post(`${CREWS_BASE}/${crewId}/remove-member`, { user_id: userId });
}

export async function leaveCrew(crewId) {
  return apiClient.post(`${CREWS_BASE}/${crewId}/leave`);
}

export async function deleteCrew(crewId) {
  return apiClient.delete(`${CREWS_BASE}/${crewId}`);
}

export async function loadCrewMembers(crewId) {
  if (!crewId) return [];
  const data = await apiClient.get(`${CREWS_BASE}/${crewId}/members`);
  return Array.isArray(data) ? data : [];
}

export async function loadCrewEntries(crewId) {
  if (!crewId) return [];
  const data = await apiClient.get(`${CREWS_BASE}/${crewId}/entries`);
  return Array.isArray(data) ? data : [];
}
